import React from "react";
import {
  useNavigate,
  useParams,
  Link,
} from "react-router-dom";

import { useViewProductImagesQuery } from "../../../redux/services/productService/product.Services";

function ViewProductImages() {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    data,
    isLoading,
    isError,
  } = useViewProductImagesQuery(id, {
    skip: !id,
  });

  if (isLoading) {
    return <h4>Loading Images...</h4>;
  }

  if (isError) {
    return <h4>Failed to load images</h4>;
  }

  return (
    <div>
      {/* Header */}
      <div className="page-header-breadcrumb all_breadcrumb">
        <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
          <nav>
            <h4 className="fw-semibold">
              View Images
            </h4>

            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>

              <li
                className="breadcrumb-item active"
                aria-current="page"
              >
                View Images
              </li>
            </ol>
          </nav>
        </div>

        <div className="page-title fw-semibold fs-18 mb-0">
          <button
            className="btn btn-primary me-2"
            onClick={() => navigate(-1)}
          >
            <i className="fe fe-arrow-left me-1"></i>
            Back
          </button>
        </div>
      </div>

      {/* Images Card */}
      <div className="card shadow p-4">
        <h3 className="mb-4">
          Product Images
        </h3>

        {data?.data?.length === 0 ? (
          <div className="alert alert-info">
            No Images Found
          </div>
        ) : (
          <div className="row g-4">
            {data?.data?.map((img) => (
              <div
                key={img.id}
                className="col-12 col-sm-6 col-md-4 col-lg-3"
              >
                <div className="card h-100 shadow-sm border-0">
                  <img
                    src={`${data?.imageBaseUrl}${img.image}`}
                    alt={img.title}
                    className="card-img-top"
                    style={{
                      height: "220px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/300x220?text=No+Image";
                    }}
                  />

                  <div className="card-body text-center">
                    <h6 className="fw-semibold mb-2">
                      {img.title}
                    </h6>

                    <span className="badge bg-primary">
                      Order : {img.image_order}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewProductImages;